import React from "react";

export default function Banner() {
  return (
    <>
      <div className="hero-section clearfix">
        <div className="hero-slider-wrapper">
          <div className="hero-slider prt-slider">
            <div className="hero-slide slide-1">
              <div className="container">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="hero-content-block">
                      <div className="hero-content">
                        <div className="pretitle slideInDown">
                          <h3>Prime Precision Imaging</h3>
                        </div>
                        <h2 style={{ fontSize: 40 }} className="title">
                          Compassionate Care
                        </h2>
                        <div className="hero-desc">
                          <p>
                            Accurate Results | Modern Technology | Patient-Centered
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hero-slide slide-2">
              <div className="container">
                <div className="row">
                  <div className="col-xl-12 col-lg-12">
                    <div className="hero-content-block">
                      <div className="hero-content">
                        <h2 className="title">
                          Medical imaging
                          <br />& <span>Radiology</span> center
                        </h2>
                        <div className="hero-desc">
                          <p>
                            Expert Insights | Visualizing Health | Transforming Lives
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
